import ShareSlide from './share'
export default ShareSlide
